module.exports = __webpack_public_path__ + "static/media/work5.c23a1ab9.jpg";